import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_SUMMARIES = [];
export const useFetchRelationshipSummaries = function useFetchRelationshipSummaries() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const enabled = !!businessId;
    const { data, isLoading, isBackgroundLoading, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.RelationshipSummaries,
            businessId,
            isVendor
        ],
        queryFn: ()=>api.relationship.getSummaries({
                businessId: businessId,
                type: 'agreementAndAdHoc',
                isVendor
            }),
        enabled,
        refreshOnHookMount
    });
    return {
        summaries: data !== null && data !== void 0 ? data : EMPTY_SUMMARIES,
        isLoading: isLoading || !enabled,
        isBackgroundLoading,
        refresh,
        error
    };
};
